(function () {
    'use strict';

    angular
        .module('externalPartyEditModule')
        .controller('ODDExternalPartyEditController', Controller);

    Controller.$inject = ['$scope', '$state', 'businessUnit', 'externalParty', 'campaigns'];

    function Controller($scope, $state, businessUnit, externalParty, campaigns) {
        $scope.businessUnit = businessUnit;
        $scope.externalParty = externalParty;
        $scope.campaigns = campaigns;

        // Add Campaign
        $scope.addCampaign = function () {
            $state.go('odd.externalPartyEdit.addCampaign');
        };

        // Go To External Party List
        $scope.goToExternalPartyList = function () {
            $state.go('odd.campaignStatusMgmt');
        };

        // Go To Campaign
        $scope.goToCampaign = function (campaign) {
            $state.go('odd.externalPartyEdit.campaign', {
                ODDCampaignID: campaign.ODDCampaignID
            });
        };
    }
})();